


let tz=+0;            //—>Offset for your timezone in hours from UTC (see http://wwp.greenwichmeantime.com/index.htm to find the timezone offset for your location)
const montharray = new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");

function countdown(selector) {
    const selectorClass = selector;
    const flashEl = document.querySelector(selectorClass);
    const bookable_until = flashEl.getAttribute('data-bookable-until');
    const bookableUntilDate = new Date(bookable_until * 1000); // multiply by 1000 so that the argument is in milliseconds, not seconds
    const yr = bookableUntilDate.getFullYear();        //—>Enter the count down target date YEAR
    const m = parseInt(("0" + (bookableUntilDate.getMonth() + 1)).slice(-2));          //—>Enter the count down target date MONTH without leading zeroes. getMonth()returns months as 0-11.
    const d = bookableUntilDate.getDate();           //—>Enter the count down target date DAY without leading zeroes
    const hr = bookableUntilDate.getHours();          //—>Enter the count down target date HOUR (24 hour clock) with leading zeroes
    const min = bookableUntilDate.getMinutes();        //—>Enter the count down target date MINUTE with leading zeroes

    const today = new Date();
    let todayFullYear = today.getFullYear();

    if (todayFullYear < 1000) {
        todayFullYear += 1900; }
        const todayMonth = today.getMonth();
        const todayDay = today.getDate();
        const todayHours = today.getHours();
        const todayMin = today.getMinutes();
        const todaySec = today.getSeconds();
        const todaystring1 = montharray[todayMonth]+" "+todayDay+", "+todayFullYear+" "+todayHours+":"+todayMin+":"+todaySec;
        const todaystring = Date.parse(todaystring1)+(tz*1000*60*60);
        const futurestring1 = (montharray[m-1]+" "+d+", "+yr+" "+hr+":"+min);
        const futurestring = Date.parse(futurestring1)-(today.getTimezoneOffset()*(1000*60));
        const dd=futurestring-todaystring;
        const dday=Math.floor(dd/(60*60*1000*24)*1);
        const dhour=Math.floor((dd%(60*60*1000*24))/(60*60*1000)*1);
        const dmin=Math.floor(((dd%(60*60*1000*24))%(60*60*1000))/(60*1000)*1);
        const dsec=Math.floor((((dd%(60*60*1000*24))%(60*60*1000))%(60*1000))/1000*1);

        if (dday<=0 && dhour<=0 && dmin<=0 && dsec<=0) {
            document.getElementById('dday').innerHTML= "0";
            document.getElementById('dhour').innerHTML="0";
            document.getElementById('dmin').innerHTML= "0";
            document.getElementById('dsec').innerHTML= "0";

            if (flashEl.classList.contains('js-flash-deal-mobile')) {
                document.getElementById('dday-mobile').innerHTML= "0";
                document.getElementById('dhour-mobile').innerHTML="0";
                document.getElementById('dmin-mobile').innerHTML= "0";
                document.getElementById('dsec-mobile').innerHTML= "0";
            }
        return;
    } else {
        document.getElementById('dday').innerHTML = dday.toString();
        document.getElementById('dhour').innerHTML = dhour.toString();
        document.getElementById('dmin').innerHTML = dmin.toString();
        document.getElementById('dsec').innerHTML = dsec.toString();

        if (flashEl.classList.contains('js-flash-deal-mobile')) {
            document.getElementById('dday-mobile').innerHTML = dday.toString();
            document.getElementById('dhour-mobile').innerHTML = dhour.toString();
            document.getElementById('dmin-mobile').innerHTML = dmin.toString();
            document.getElementById('dsec-mobile').innerHTML = dsec.toString();
        }

        // Refresh every second
        setTimeout(function() {
            countdown(selectorClass);
        }, 1000);
    }

    if (flashEl.classList.contains('d-md-none')) {
        flashEl.classList.remove('d-md-none');
        flashEl.classList.add('d-md-block');
    }

    if (flashEl.classList.contains('js-flash-deal-mobile')) {
        flashEl.classList.remove('d-none');
    }
 }

export {countdown};
